module.exports = __webpack_public_path__ + "73efe61138a7fab256b2ceee0dad4e42.svg";